import axios from "axios";
import { getEnvironment } from "../utils/getEnvironment";
import { PeriodSelection } from "../components/Dashboard/Analytics/types";

const environment = getEnvironment();

export interface ClientOverview {
    totalClients: number;
    activeCount: number;
    newThisPeriod: number;
    newLastPeriod: number;
    returningRatePct: number;
    avgVisitsPerClient: number;
}

export interface TopClient {
    name: string;
    revenue: number;
    visits: number;
    avgValue: number;
}

export interface ClientHealth {
    churnRiskCount: number;
    lostCount: number;
    oneTimerCount: number;
    churnRisk: { name: string; daysSince: number }[];
    lost: { name: string; daysSince: number }[];
    oneTimers: { name: string }[];
}

export interface ClientAnalyticsData {
    overview: ClientOverview;
    topClients: TopClient[];
    health: ClientHealth;
}

export default class ClientAnalytics {
    public static readonly info = async (
        uuid: string,
        brand: string,
        location: string,
        selection: PeriodSelection
    ) => {
        const params: Record<string, string> = {
            period: selection.period,
            date: selection.date,
        };
        if (selection.period === "custom") {
            if (selection.from) params.from = selection.from;
            if (selection.to) params.to = selection.to;
        }
        return (await axios
            .get(
                `${environment.api_url}/${brand}/location/${location}/analytics/client-analytics`,
                { headers: { "User-Token": uuid }, params }
            )
            .then((res) => (res.status === 200 ? res.data : undefined))
            .catch(console.error)) as ClientAnalyticsData | undefined;
    };
}
